import { api } from '../../lib/api.ts';
import type { OrgUserRow, OrgUserPatch } from '../users/api.ts';

export interface OrgRow {
  id: string;
  name: string;
  contactEmail: string;
  status: 'ACTIVE' | 'SUSPENDED';
  createdAt: string;
  _count: { users: number };
}

export interface BootstrapInviteResult {
  invite: { id: string; email: string; role: string; expiresAt: string };
}

export const orgsApi = {
  list: (page = 1, pageSize = 20) =>
    api.get<{ orgs: OrgRow[]; total: number; page: number; pageSize: number }>('/admin/organizations', { params: { page, pageSize } })
      .then((r) => r.data),
  get: (id: string) =>
    api.get<{ org: OrgRow }>(`/admin/organizations/${id}`).then((r) => r.data.org),
  create: (name: string, contactEmail: string) =>
    api.post<{ org: OrgRow }>('/admin/organizations', { name, contactEmail }).then((r) => r.data),
  setStatus: (id: string, status: 'ACTIVE' | 'SUSPENDED') =>
    api.patch<{ org: OrgRow }>(`/admin/organizations/${id}`, { status }).then((r) => r.data),
  bootstrapOrgAdmin: (orgId: string, email: string, role: string) =>
    api.post<BootstrapInviteResult>(`/admin/organizations/${orgId}/invites`, { email, role }).then((r) => r.data),
  listUsers: (orgId: string) =>
    api.get<{ users: OrgUserRow[] }>(`/admin/organizations/${orgId}/users`).then((r) => r.data.users),
  updateUser: (orgId: string, userId: string, patch: OrgUserPatch) =>
    api.patch<{ user: OrgUserRow }>(`/admin/organizations/${orgId}/users/${userId}`, patch).then((r) => r.data.user),
  resetUserPassword: (orgId: string, userId: string) =>
    api.post(`/admin/organizations/${orgId}/users/${userId}/reset-password`),
};
